import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { RayCodeAction, ServiceAction, ProductAction } from '../../actions';
import { useTranslation } from 'react-i18next';
import { Translate as t } from '../../config/Translate';

const ServiceClaimCategory = ({ service, pInfo, UpdateService, GetRayCodes, callback, clist }) => {
	// const [t] = useTranslation();
	const [codes, setCodes] = useState([]);
	const [comboParent, setComboParent] = useState([]);
	const [combo, setCombo] = useState([]);
	// BUG-090 후속: useState 초기값을 service 로부터 즉시 채워 첫 렌더 transient ("- / -") 차단.
	// SetCodeData useEffect 도 codes 로드 후 동일하게 동기화 (defense-in-depth).
	const [info, setInfo] = useState({
		category: service?.category,
		categoryDetail: service?.categoryDetail,
	});
	const [hide, setHide] = useState(!!service._id);

	const [showOther, setShowOther] = useState(false);
	const [otherText, setOtherText] = useState();
	const [otherSaveShow, setotherSaveShow] = useState(false);

	// BUG-090: 호출자 분산 누락 회귀 차단을 위해 mount 시 자체 fetch.
	useEffect(() => {
		GetRayCodes();
	}, [GetRayCodes]);

	useEffect(() => {
		setCodes(clist?.filter(x => x.type === 'CLAIMTYPE'));
	}, [clist])

	// BUG-090 후속: pInfo 미전달 호출자(AdminServiceInfo / ServiceDetail / 제품 없이 연 ServiceCreateForm)
	// 에서도 SetCodeData 가 실행되어 universal 카테고리 코드(`!x.category`) 가 노출되도록 가드 완화.
	useEffect(() => {
		if (codes.length > 0) {
			SetCodeData();
		}
	}, [codes, pInfo])

	const SetCodeData = () => {
		const groups = [];
		codes.filter(hasOwnFilter).map(x => groups.push(x.group));
		const newList = [...new Set(groups)];
		setComboParent(newList);
		if (!service._id) {
			setInfo({ ...info, ["category"]: newList[0] });
		} else {
			setInfo({
				category: service.category,
				categoryDetail: service.categoryDetail
			});
		}
	}

	const hasOwnFilter = (x) => {
		const model = pInfo?.model;
		if (model && codes.find(c => c.category === model)) {
			return x.category === model;
		} else {
			return !x.category;
		}
	}

	// BUG-090 후속: deps 에 codes 추가. useState 초기값으로 info.category 가 mount 시점부터
	// service 값 보유 → 첫 fire 시 codes 빈 상태로 early return → codes 로드 후 info.category
	// 변경 없어 재실행 안됨 → combo=[] 잔존으로 expand 시 detail dropdown 빈 상태 회귀.
	useEffect(() => {
		if (!info.category || codes.length == 0)
			return;

		if (info.category != "Other") {
			setShowOther(false);
			const list = [];
			list.push({ code: "", name: "Select a detail category" });
			codes.filter(hasOwnFilter).sort((a, b) => {
				if (a.sortnumber > b.sortnumber)
					return 1;

				if (a.sortnumber < b.sortnumber)
					return -1;

				return 0;
			}).map(x => {
				if (x.group == info.category)
					list.push(x);
			});
			setCombo(list);

			if (!service._id) {
				setInfo({ ...info, ["categoryDetail"]: list[0].code });
			}
		} else {
			setShowOther(true);
		}
	}, [info.category, codes])

	// BUG-090 후속: deps 에 info.category 추가. ServiceCreate 에서 user 가 parent 만 변경 시
	// useEffect[info.category, codes] 가 setInfo({categoryDetail:""}) 하지만 값 미변경 → 본 effect
	// fire 안됨 → callback 미호출 → newService.category stale (firstGroup) → BE 저장 시 user 가
	// 의도한 category 미반영. 신규 서비스는 parent/detail 두 변경 모두 callback 으로 전달 필요.
	useEffect(() => {
		if (codes.length == 0)
			return;

		if (service._id) {
			if (info.category != "Other") {
				if (info.categoryDetail && info.category && service.categoryDetail != info.categoryDetail) {
					update();
				}
			}
		} else {
			callback && callback(info);
		}
	}, [info.category, info.categoryDetail])

	const changeCombo = (e) => {
		let item = {};
		codes.map(x => {
			if (x.code == e.target.value && x.group == info.category)
				item = x;
		});
		setInfo({ ...info, ["categoryDetail"]: item.code });
	}

	const changeComboParent = (e) => {
		setInfo({ ...info, ["category"]: e.target.value });
	}

	const update = () => {
		UpdateService(service._id, info);
		setHide(true);
	}

	const chkandsubmit = () => {
		if (info.categoryDetail.length > 0) {
			if (service._id) {
				if (info.category && service.categoryDetail != info.categoryDetail) {
					update();
				}
			} else {
				callback && callback(info);
			}
		}
	}

	const detailName = (code) => {
		if (!code) return '';
		// BUG-090 후속: codes 미로드 또는 레거시 코드 매칭 실패 시 빈 문자열 반환 시
		// 헤더에 "Hardware / -" 로 detail 손실. fallback 으로 code 자체 노출.
		const result = codes.find(item => item.code == code);
		return result ? result.name : code;
	};

	return (
		<div>
			<div className="card-header" onClick={() => setHide(!hide)}>
				{t('service.field.claimCategory')}
				<div className="float-end ms-2">
					<ion-icon name={hide ? "chevron-down-outline" : "chevron-up-outline"}></ion-icon>
				</div>
				{hide && <div className="float-end">
					{info.category || "-"} / {detailName(info.categoryDetail) || "-"}
				</div>}
			</div>
			{!hide && <div className="card-body">
				<select className="form-control mb-1"
					value={info.category}
					onChange={(e) => changeComboParent(e)}>
					{comboParent.map(x => <option value={x}>{x}</option>)}
				</select>
				{showOther && <>
					<input type="text" className="form-control mb-1"
						value={info.categoryDetail}
						onChange={(e) => { setInfo({ ...info, categoryDetail: e.target.value }); setotherSaveShow(e.target.value.length > 0) }} />
					{(service._id && otherSaveShow) && <button className="btn btn-block btn-primary" onClick={() => chkandsubmit()}>{t('common.button.update')}</button>}
				</>}
				{!showOther && <select className="form-control"
					value={info.categoryDetail}
					onChange={(e) => changeCombo(e)}>
					{combo.map(x => <option value={x.code}>{x.name}</option>)}
				</select>}
			</div>}
		</div>
	);
};

const mapState = (state) => {
	const service = state.ServiceReducer.service;
	const clist = state.RayCodeReducer.items;
	return { service, clist };
};

const mapDispatch = (dispatch) => ({
	UpdateService: (_id, info) => dispatch(ServiceAction.UpdateService(_id, info)),
	GetRayCodes: () => dispatch(RayCodeAction.GetAll()),
});

export default connect(mapState, mapDispatch)(ServiceClaimCategory);
